//	Pure helpers: formatting, the leaderboard query, and the cascading
//	country → state → city filter rules. No DOM, no network.

export const PLACE = ['1ST', '2ND', '3RD'];
export const PAGE_SIZE = 50;
export const FILTER_KEYS = ['country', 'state', 'city'];
export const FILTER_LABEL = {country: 'All countries', state: 'All states', city: 'All cities'};

export function fmt(n) {
	return Number(n).toLocaleString('en-US');
}

//	"today" · "3d ago" · "2w ago" · "4mo ago" · "2y ago"
export function ago(iso, now = Date.now()) {
	const days = Math.floor((now - new Date(iso).getTime()) / 86_400_000);
	if (!Number.isFinite(days) || days < 1) return 'today';
	if (days < 14) return `${days}d ago`;
	if (days < 60) return `${Math.round(days / 7)}w ago`;
	if (days < 365) return `${Math.round(days / 30)}mo ago`;
	return `${Math.round(days / 365)}y ago`;
}

//	"Portland, OR · US"; blanks are skipped; no location at all → ''.
export function place(location) {
	if (!location) return '';
	const cityState = [location.city, location.state].filter(Boolean).join(', ');
	return [cityState, location.country].filter(Boolean).join(' · ');
}

export function avatarUrl(player) {
	return player?.profileAvatar?.contents?.image?.url ?? player?.profileAvatar?.url ?? null;
}

export function initial(username) {
	return (
		(username || '')
			.replace(/[^a-z0-9]/gi, '')
			.charAt(0)
			.toUpperCase() || '?'
	);
}

//	The public board: every AGS, one row per player (the API's default mode).
export function boardQuery({gameVersionID, page = 1, filters = {}, count = PAGE_SIZE}) {
	const q = new URLSearchParams({
		gameVersionID: String(gameVersionID),
		scope: 'global',
		page: String(page),
		count: String(count),
	});
	FILTER_KEYS.forEach((k) => {
		if (filters[k]) q.set(k, filters[k]);
	});
	return q.toString();
}

//	Changing a level clears the levels below it (a state needs its country,
//	a city its state), which is also what the API enforces.
export function applyFilter(filters, key, value) {
	const next = {...filters, [key]: value || ''};
	const i = FILTER_KEYS.indexOf(key);
	FILTER_KEYS.slice(i + 1).forEach((k) => {
		next[k] = '';
	});
	return next;
}

export function filterSummary(filters) {
	return [filters.city, filters.state, filters.country].filter(Boolean).join(', ') || 'every AGS';
}

//	Dropdown options for one level, from the locations seen so far, narrowed
//	by the levels above it. Sorted, de-duplicated, blanks dropped.
export function filterOptions(locations, filters, key) {
	const i = FILTER_KEYS.indexOf(key);
	const above = FILTER_KEYS.slice(0, i);
	const values = locations
		.filter((l) => l && above.every((k) => !filters[k] || l[k] === filters[k]))
		.map((l) => l[key])
		.filter(Boolean);
	return [...new Set(values)].sort();
}

export function pageRange({page, shown, count}) {
	if (!count) return '';
	const from = (page - 1) * PAGE_SIZE + 1;
	const pages = Math.max(1, Math.ceil(count / PAGE_SIZE));
	return `Players ${from}–${from + shown - 1} of ${fmt(count)} · page ${page} of ${pages}`;
}
